import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';
import { BoundingBox } from '@/types';

interface ChunkMatch {
  id: string;
  content: string;
  boundingBoxes: BoundingBox[] | null;
}

export const useGetDocumentChunkMatches = (caseId: string, docId: string, searchQuery: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<{ chunks: ChunkMatch[] }>(
    [QueryEntity.DocumentChunkMatches, { caseId, docId, searchQuery }],
    () => {
      const params = new URLSearchParams({ searchQuery });
      return fetch(`${APIBaseChronos}/api/case/${caseId}/docs/${docId}/chunk-matches?${params}`, fetchConfigGET).then(
        (res) => res.json(),
      );
    },
    {
      enabled: !!caseId && !!docId && !!searchQuery && searchQuery.trim() !== '',
      refetchOnWindowFocus: false,
    },
  );
};
